import React, { useState, useEffect } from "react";
import axios from "axios";
import { Paper } from "@mui/material";
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
import { FiMapPin, FiHome, FiDollarSign, FiSearch, FiPhoneCall, FiShield, FiSquare } from 'react-icons/fi';
import { Navbar } from "./Navbar";
import '../../css/SearchPage.css';
import '../../css/PropertyList.css'
import PropertyList from "./PropertyList";
import noresultsfound from '../../images/no-results found.jpeg';


const SearchPage = () => {
  const [properties, setProperties] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const limit = 50;
  const location = useLocation(); 
  const navigate = useNavigate();

  const [filters, setFilters] = useState({
    pincode: "",
    locality: "",
    propertyType: "",
    proptypename: "",
    listingType: "",
    proptypename: "",
    bhk: "",
    furnishingType: "",
    sqRange: "",
    availableFrom: "",
    residentialPrice: "",
    commercialPrice: ""
  });

  const [searchParams] = useSearchParams();

  useEffect(() => {
    const newFilters = Object.fromEntries(searchParams.entries());
    setFilters((prev) => ({ ...prev, ...newFilters }));
    fetchProperties(1, newFilters);
  }, [searchParams.toString()]);

  const fetchProperties = async (page, appliedFilters = {}) => {
    try {
      const response = await axios.get("/api/search", {
        params: { ...appliedFilters, page, limit },
      });

      setProperties((prev) =>
        page === 1 ? response.data.properties : [...prev, ...response.data.properties]
      );
      setTotalPages(response.data.totalPages);
      setCurrentPage(page);
    } catch (error) {
      console.error("❌ Error fetching search results:", error);
    }
  };

  const handleSearch = () => {
    const filteredParams = Object.fromEntries(
      Object.entries(filters).filter(([_, value]) => value !== "")
    );
    navigate({
      pathname: "/search",
      search: new URLSearchParams(filteredParams).toString(),
    });
  };

  const loadMore = () => {
    if (currentPage < totalPages) {
      fetchProperties(currentPage + 1, filters);
    }
  };

  return (
    <div>
      <Navbar />
      <div className="container1">
        <div className="filterContainer">
          {/* Updated filter layout */}
       	
          <select
            value={filters.propertyType}
            onChange={(e) => setFilters({ ...filters, propertyType: e.target.value })}
          >
            <option value="">Select Property Type</option>
            <option value="Residential">Residential</option>
            <option value="Commercial">Commercial</option>
          </select>
          <select
            value={filters.listingType}
            onChange={(e) => setFilters({ ...filters, listingType: e.target.value })}
          >
            <option value="">Select Listing Type</option>
            <option value="Rent">Rent</option>
            <option value="Resale">Resale</option>
            {filters.propertyType === "Residential" && <option value="PG/Co-living">PG / Co-Living</option>}
          </select>

          {filters.propertyType === "Residential" && (
            <>
	<select
            value={filters.proptypename}
            onChange={(e) => setFilters({ ...filters, proptypename: e.target.value })}
          >
            <option value="">Select Type</option>
            <option value="Apartment">Apartment</option>
            <option value="Villa">Villa</option>
            <option value="Plot">Plot</option>
          </select>
              <select
                value={filters.bhk}
                onChange={(e) => setFilters({ ...filters, bhk: e.target.value })}
              >
                <option value="">Select BHK</option>
                <option value="1 BHK">1 BHK</option>
                <option value="2 BHK">2 BHK</option>
                <option value="3 BHK">3 BHK</option>
              </select>
              <select
                value={filters.furnishingType}
                onChange={(e) => setFilters({ ...filters, furnishingType: e.target.value })}
              >
                <option value="">Select Furnishing</option>
                <option value="Fully Furnished">Fully Furnished</option>
                <option value="Semi Furnished">Semi Furnished</option>
                <option value="Unfurnished">Unfurnished</option>
              </select>
           
            </>
          )}

          {filters.propertyType === "Commercial" && (
            <>
	   <select
            value={filters.proptypename}
            onChange={(e) => setFilters({ ...filters, proptypename: e.target.value })}
          >
            <option value="">Select Type</option>
            <option value="Apartment">Plot</option>
            <option value="Villa">Warehouse</option>
            <option value="Plot">OficeSpace</option>
          </select>
              <select
                value={filters.sqRange}
                onChange={(e) => setFilters({ ...filters, sqRange: e.target.value })}
              >
                <option value="">Select Sq. Ft Range</option>
                <option value="0-1000">0-1000 sqft</option>
                <option value="1000-2000">1000-2000 sqft</option>
                <option value="2000-5000">2000-5000 sqft</option>
              </select>
          
            </>
          )}
          <input
            type="text"
            placeholder="Locality"
            value={filters.locality}
            onChange={(e) => setFilters({ ...filters, locality: e.target.value })}
          />
          <button onClick={handleSearch}>Search</button>
        </div>


<div className="project-list-new">
        <u>  <h2>Properties</h2></u>
        <div className="projects-grid">
          {properties.length === 0 ? (
            <div className="no-results">
              <img src={noresultsfound} alt="No results" className="no-results-img" />
              <p className="no-results-text">No projects found matching your criteria.</p>
            </div>
          ) : (
            properties.map((project) => (

              <div key={project.projectid} className="property-card1"  onClick={() => navigate(`/property/${project.category}/${project.id}`)}>
                <div className="card-image">
                  <img src={project.image} alt={project.bpn} />
                  <span className="badge verified"><FiShield /> Verified</span>
                </div>
                <div className="card-content">
                  <h3>{project.bpn}</h3> 
                  <div className="flex">
                    <p className="devr">{project.proptypename}</p>
                  </div>
                  <p className="icon-text"><FiMapPin /> {project.city}, {project.pinlocality}</p>
                  <div className='flex'>
                    <p className="icon-text">
                   {project.bhk && (
  <span><FiHome /> {project.bhk.replace(/bhk/gi, '').split(',').join(' & ')} BHK</span>
)}
                     {project. buitupareasq &&(<span><FiSquare/> {project. buitupareasq}</span>) }
                    </p>
                    <p className="icon-text">
                      {project.cost && (<span>₹{project.cost}</span>)}
                    </p>
                  </div>
                  <div className="card-actions">
                    <button className="btn view"><FiSearch /> View Details</button>
                  </div>
                </div>
              </div>
            ))
          )}
        </div>
      </div>

      </div>
    </div>
  );
};

export default SearchPage;
